export const AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY =
  "efm-audit-dashboard-snapshot-v1";
export const AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY =
  "efm-audit-dashboard-restore-flag-v1";

/** List or details under reporting (same tab session snapshot is only for this subtree). */
export function isAuditReportingNavigationTarget(path: string | undefined): boolean {
  if (path == null || typeof path !== "string") {
    return false;
  }
  const base = path.split("?")[0].split("#")[0];
  return (
    base === "/audit-reporting" ||
    base.startsWith("/audit-reporting/")
  );
}

/** List route only — not details (`/audit-reporting/audit-details-page/...`). */
export function isAuditReportingListPath(path: string | undefined): boolean {
  if (path == null || typeof path !== "string") {
    return false;
  }
  const base = path.split("?")[0].split("#")[0].replace(/\/+$/, "");
  return base === "/audit-reporting";
}

export function clearAuditDashboardSessionStorage(): void {
  try {
    if (typeof sessionStorage === "undefined") {
      return;
    }
    sessionStorage.removeItem(AUDIT_DASHBOARD_SESSION_SNAPSHOT_KEY);
    sessionStorage.removeItem(AUDIT_DASHBOARD_SESSION_RESTORE_FLAG_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}

/** Call from routeExit: drop list snapshot when leaving the audit reporting area. */
export function clearAuditDashboardSessionStorageOnRouteExit(
  context: { path?: string } | undefined
): void {
  if (isAuditReportingNavigationTarget(context?.path)) {
    return;
  }
  clearAuditDashboardSessionStorage();
}

type AuditDashboardResultRow = { status?: string };

/** ponytail: audit-search run status is success|error|init; skipped rows were init remap bug (ACME-1497) */
export function repairLegacyRemappedInitStatus<T extends AuditDashboardResultRow>(
  row: T,
): T {
  const status = String(row.status ?? "").trim().toLowerCase();
  if (status !== "skipped") {
    return row;
  }
  return { ...row, status: "init" };
}

export function repairLegacyRemappedInitResults<T extends AuditDashboardResultRow>(
  results: T[] | undefined,
): T[] {
  return (results ?? []).map(repairLegacyRemappedInitStatus);
}

export function repairLegacyRemappedInitAuditPayload<
  T extends { results?: AuditDashboardResultRow[] },
>(data: T): T {
  return { ...data, results: repairLegacyRemappedInitResults(data.results) };
}
